import React, { useState } from 'react';

const UnitCard = ({ unit, onInquire, onImageClick, onStatusChange, isAdmin, onVideoClick }) => {
  const [paymentOption, setPaymentOption] = useState('20');

  const handlePaymentChange = (e) => {
    setPaymentOption(e.target.value);
  };

  return (
    <div className={`unit-card ${unit.status}`}>
      <div className={unit.status}>
        <span className="status-dot"></span>
        <small style={{ textTransform: 'uppercase', letterSpacing: '1px' }}>{unit.status}</small>
      </div>
      <h3 style={{ margin: '10px 0' }}>Unit {unit.id}</h3>
      <p style={{ fontSize: '0.9rem', opacity: 0.8 }}>{unit.type}<br />{unit.sqft} m. sq.</p>
      
      <div>
        <p style={{ fontWeight: 'bold', fontSize: '1.2rem' }}>
          {new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(unit.pricing[paymentOption])}
        </p>
        <select value={paymentOption} onChange={handlePaymentChange} style={{marginBottom: '10px'}}>
          <option value="20">20% Down Payment</option>
          <option value="50">50% Down Payment</option>
          <option value="100">100% Full Payment</option>
        </select>
      </div>
      
      {unit.status === 'available' ? (
        <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap' }}>
          <button className="btn-action" onClick={() => onImageClick(unit.image)}>Floor Plan</button>
          {onVideoClick && (
            <button className="btn-action" onClick={() => onVideoClick(unit)}>
              Interior View
            </button>
          )}
          <button className="btn-action" onClick={() => onInquire(unit)}>Inquire Now</button>
          {isAdmin && <button className="btn-action" onClick={() => onStatusChange(unit.id)}>Mark as Unavailable</button>}
        </div>
      ) : unit.status === 'reserved' ? (
        <button className="btn-disabled">Reserved</button>
      ) : (
        isAdmin 
          ? <button className="btn-action" onClick={() => onStatusChange(unit.id)}>Mark as Available</button>
          : <button className="btn-disabled">Sold</button>
      )}
    </div>
  );
};

const UnitGrid = ({ units, onInquire, onImageClick, onStatusChange, isAdmin, onVideoClick }) => (
  <div className="unit-grid">
    {units.map(unit => (
      <UnitCard
        key={unit.id}
        unit={unit}
        onInquire={onInquire}
        onImageClick={onImageClick}
        onStatusChange={onStatusChange}
        isAdmin={isAdmin}
        onVideoClick={onVideoClick}
      />
    ))}
  </div>
);

export default UnitGrid;
